import { render } from "./CommonHeader.vue?vue&type=template&id=07f32d47&scoped=true"
import script from "./CommonHeader.vue?vue&type=script&lang=js"
export * from "./CommonHeader.vue?vue&type=script&lang=js"

import "./CommonHeader.vue?vue&type=style&index=0&id=07f32d47&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f32d47"]])

export default __exports__